import {useEffect} from 'react';

import {sendEmailToDataLayer} from 'features/analytics/sendEmailToDataLayer';
import {useGetCustomerEmail} from 'hooks/getCustomerData/getCustomerData';

/**
 * Send data for Data Layer
 */
export function useSendDataLayer() {
    const email = useGetCustomerEmail();

    useEffect(() => {
        if (email) {
            sendEmailToDataLayer(email);
        }
    }, [email]);
}
